import React from 'react';
import { Layout } from '~/source/ui/layout/layout';
import type { Home as Props } from './home.page.types';
import { LineGraph } from './line-graph';
import { Panel } from './panel';
import { RoundProgress } from './round-progress';

export const Home: React.FC<Props> = ({ debug, layout, stats }) => (
  <Layout {...layout}>
    <main className="home">
      <div className="home__panels">
        <Panel {...stats.statuses.panel} width="1/3">
          <RoundProgress {...stats.statuses.content} />
        </Panel>
        <Panel {...stats.members.panel} width="2/3">
          <LineGraph {...stats.members.content} />
        </Panel>
        {stats.visits ? (
          <Panel {...stats.visits.panel} width="1/2">
            <LineGraph {...stats.visits.content} />
          </Panel>
        ) : null}
        {stats.gx ? (
          <Panel {...stats.gx.panel} width="1/2">
            <LineGraph {...stats.gx.content} />
          </Panel>
        ) : null}
      </div>
      {debug ? (
        <code>
          <pre>{debug}</pre>
        </code>
      ) : null}
    </main>
  </Layout>
);
